import { getIsAuthenticated } from '../../utils/getIsAuthenticated';

export function protect<TCallback extends Function>(
    callback: TCallback,
    retpath?: string,
): TCallback {
    return ((...args: unknown[]) => {
        if (!getIsAuthenticated()) {
            window.location.href = `${process.env.REACT_APP_PASSPORT_URL}/auth?retpath=${
                retpath ?? window.location.href
            }`;
        }

        return callback(...args);
    }) as any;
}
